<template>
    <div>
        <h5>{{group_name}}</h5>
        <el-container>
            <el-aside width="180px">
                <SubMenu activeIndex="6" />
            </el-aside>
            <el-main>
                <el-row type="flex" justify="center">
                    <el-col :span="10">
                        <el-form ref="form">
                            <el-form-item label="组织名称" prop="name">
                                <el-input v-model="group_name"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" class="btn-create" @click="handleEditGroup">修改</el-button>
                                <el-button type="danger" class="btn-create" @click="handleDelete">删除</el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
            </el-main>
        </el-container>
    </div>
</template>
<script>
import axios from 'axios';
import config from '../config.js'
import SubMenu from './SubMenu.vue'
export default {
    components: {
        SubMenu
    },
    data() {
        return {
            group_id: '',
            group_name: '',
        }
    },
    created() {
        //console.log(this.$route.params.group_id)
        this.group_id = this.$route.params.group_id;
        this.getGroup();
    },
    methods: {
        getGroup() {
            let url = config.base_url + '/yun_table/yun_duixiang_groups/' + this.group_id
            axios.get(url, {
                headers: {
                    "Authorization": localStorage.getItem('token')
                }
            }).then((response) => {
                let res = response.data
                this.group_id = res.group_id
                this.group_name = res.group_name
            })
        },
        handleEditGroup() {
            let _this = this;
            axios({
                    method: 'put',
                    headers: {
                        "Authorization": localStorage.getItem('token')
                    },
                    url: config.base_url + '/yun_table/yun_duixiang_groups/' + this.group_id,
                    data: {
                        group_name: this.group_name
                    }
                })
                .then(function(response) {
                    //console.log(response)
                    _this.$message({
                        message: '组织修改成功',
                        type: 'success'
                    });
                })
                .catch((err) => {
                    //console.log(err.response)
                    let err_data = err.response.data.err_msg
                    this.$message({
                        message: err_data,
                        type: 'error'
                    })
                })
        },
        handleDelete() {
            let _this = this;
            this.$confirm('此操作将永久删除该组织及所属所有对象, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                axios({
                        method: 'delete',
                        headers: {
                            "Authorization": localStorage.getItem('token')
                        },
                        url: config.base_url + '/yun_table/yun_duixiang_groups/' + _this.group_id
                    }).then(function(response) {
                        console.log(response)

                        _this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        _this.$router.push({
                            path: '/newduixiang'
                        })
                    })
                    .catch((err) => {
                        //console.log(err.response)
                        let err_data = err.response.data.err_msg
                        this.$message({
                            message: err_data,
                            type: 'error'
                        })
                    })

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },


    }

}
</script>
<style>
</style>